import { render, staticRenderFns } from "./TransfersList.vue?vue&type=template&id=2d65626a"
import script from "./TransfersList.vue?vue&type=script&lang=js"
export * from "./TransfersList.vue?vue&type=script&lang=js"
import style0 from "./TransfersList.vue?vue&type=style&index=0&id=2d65626a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports